<template>
    <v-container fluid>
        <v-card color="#6499faff" dark class="rounded-xl">
            <v-card-title>
                <v-row align="center">
                    <v-col cols="12" lg="4">
                        {{ $t('menu.memberships') }}
                    </v-col>
                    <!-- <v-col cols="12">
                        <membership-filters @setFilters="setFilters"/>
                    </v-col> -->
                    <v-col cols="12" align="end">
                        <v-btn class="my-2 mr-2" dark small color="black" @click="createMembership">
                            <v-icon dark>mdi-plus</v-icon>{{ $t('button.create') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <array-view
            :items="memberships"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @onDelete="onDelete"
        />
    </v-container>
</template>

<script>
    import membershipService from '@/services/membership'
    import ArrayView from '@/components/ArrayView'
    // import MembershipFilters from '@/components/MembershipFilters'

    export default {
        name: 'Membership',
        components: { ArrayView },
        data: () => {
            return {
                memberships: [],
                displayInfo: [
                    { text: 'table.id', value: 'id' },
                    { text: 'table.name', value: 'name' },
                    { text: 'table.type', value: 'type' },
                    { text: 'table.maxVisits', value: 'maxVisits' },
                    { text: 'table.price', value: 'price' }
                ],
                size: 100,
                totalPages: 0,
                page: 1,
                loading: false,
                filters: null,
                message: null
            }
        },
        watch: {
            filters: {
                handler() {
                    this.fetchFilteredMemberships()
                }
            }
        },
        created() {
            this.filters = this.$store.getters.getMembershipFilters
            this.page = this.$store.getters.getPage
            this.fetchFilteredMemberships()
        },
        methods: {
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.$store.dispatch('setPage', page)
                this.fetchFilteredMemberships()
            },
            handleClick(action, item) {
                this.$router.push(`/memberships/${item.id}/${action}`)
            },
            createMembership() {
                this.$router.push(`/memberships/create`)
            },
            onDelete(item, page) {
                membershipService.deleteMembership(item.id).then(() => {
                    this.page = page
                    this.fetchFilteredMemberships()
                })
            },
            setFilters(filters) {
                this.filters = filters
                this.$store.dispatch('setMembershipFilters', this.filters)
            },
            fetchFilteredMemberships() {
                this.loading = true
                membershipService.getFilteredMemberships(this.filters, this.page, this.size).then(resp => {
                    this.memberships = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
